
import downloadIcon from '../../../../../assets/img/download__icon.svg'
import { getBaseUrl } from '~/config/api'
export default {
  name: 'DownloadAgreementButton',
  data() {
    return {
      downloadIcon,
    }
  },
  methods: {
    async clickHandler() {
      const response = await this.$axios({
        url: `${getBaseUrl(
          process.env.NODE_ENV
        )}/api/auth/user/pdf-improvements`,
        method: 'GET',
        responseType: 'blob',
      })
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Service Agreement.pdf')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
}
